import React from 'react';
import ReactApexChart from "react-apexcharts";

import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const formatMB = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const mb = bytes / (1024*1024*1024);
    const dm = decimals < 0 ? 0 : decimals;

    return parseFloat(mb.toFixed(dm));
  };

const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  };

const SimpleDonutCharts = ({dataColors, img, dcm, otr}) => {
    let sisa = 26843570600 - img - dcm - otr;
    var chartDonutBasicColors = getChartColorsArray(dataColors);
    const series = [formatMB(img), formatMB(dcm), formatMB(otr), formatMB(sisa)]
    var options = {
        chart: {
            height: 330,
            type: 'donut',
        },
        labels: ["Media", "Documents", "Others", "Free Space"],
        dataLabels: {
            dropShadow: {
                enabled: false,
              }
        },
        legend: {
            position: 'bottom'
        },
        colors: chartDonutBasicColors
    };
    return (
        <ReactApexChart
            series={series}
            options={options}
            type="donut"
            height={330}
            className="apex-charts mt-3" />

    )
}

export default SimpleDonutCharts;
